/**
 * Bloc reconciliation renvoyé par GET /customers/... et GET .../loyalty.
 * @typedef {{
 *   requestedProfileId?: string,
 *   loyaltyProfileId?: string,
 *   reconciledBy?: string,
 *   showMergeNotice?: boolean,
 *   unomiSync?: { synced?: boolean, profileId?: string },
 * }} LoyaltyReconciliation
 */

/** Fusionne le premier bloc reconciliation trouvé (loyalty puis customer). */
export function pickReconciliation(...sources) {
    for (const data of sources) {
        const block = data?.reconciliation;
        if (block && typeof block === "object") return block;
    }
    return null;
}

/** Bandeau admin — uniquement si le backend le demande explicitement. */
export function shouldShowMergeNotice(reconciliation) {
    return reconciliation?.showMergeNotice === true;
}

/**
 * Message d'avertissement lorsque showMergeNotice est true.
 * @param {LoyaltyReconciliation|null|undefined} reconciliation
 * @param {{ email?: string }} [context]
 */
export function getMergeNoticeMessage(reconciliation, { email } = {}) {
    const emailNorm = String(email || "").trim();
    const requested = reconciliation?.requestedProfileId;
    const loyalty = reconciliation?.loyaltyProfileId;

    if (!emailNorm) {
        return "Impossible de réconcilier ce profil avec le compte fidélité : ajoutez l'email du client pour lier le profil CDP au programme de fidélité.";
    }

    if (requested && loyalty && String(requested) !== String(loyalty)) {
        return `L'email (${emailNorm}) ne permet pas de réconcilier ce profil CDP (${requested}) avec le compte fidélité (${loyalty}). Vérifiez l'email du contact.`;
    }

    return `L'email (${emailNorm}) ne correspond pas au client fidélité attendu pour ce profil. Vérifiez l'email du contact.`;
}

/** ProfileId à utiliser dans les URLs API (profil consulté, pas le master interne). */
export function resolveViewProfileId(entryProfileId, reconciliation) {
    return String(
        reconciliation?.requestedProfileId
        || entryProfileId
        || "",
    ).trim();
}

/** ProfileId maître fidélité (customer_id / alias maître). */
export function resolveLoyaltyProfileId(reconciliation, loyaltyData, fallback = "") {
    return String(
        reconciliation?.loyaltyProfileId
        || loyaltyData?.profileId
        || loyaltyData?.profile_id
        || fallback
        || "",
    ).trim();
}
